<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">经营存款数据汇总</span>
      <span class="dark4-color ">提示：按 Ctrl + F 键并输入可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
      <account-date-choose v-model="accountDate"/>
      <Button color="primary" @click="add" class="margin-left">数据汇总</Button>
      <Button color="primary" @click="exportExcel">导出Excel</Button>
      <Button :loading="loading1" :disabled="selectedItems.length === 0" color="red" @click="batchDelete">批量删除</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="dataDian" :border="true" @select="handleSelectChange" :checkbox="true" stripe >
        <TableItem title="序号" :width="50">
          <template v-slot="{ index, data }">
            {{ index + 1 }}
          </template>
        </TableItem>
        <TableItem title="部门名称" prop="dianName" :width="100"></TableItem>
        <TableItem title="日期" prop="heusanDate" :width="80"></TableItem>
        <TableItem title="工资" prop="h300401"></TableItem>
        <TableItem title="房租费" prop="h300402"></TableItem>
        <TableItem title="装修费" prop="h300403"></TableItem>
        <TableItem title="燃气水电费" prop="h300404"></TableItem>
        <TableItem title="工商税费" prop="h300405"></TableItem>
        <TableItem title="折旧费" prop="h300406"></TableItem>
        <TableItem title="低值易耗" prop="h300407"></TableItem>
        <TableItem title="修理费" prop="h300408"></TableItem>
        <TableItem title="社保费" prop="h300409"></TableItem>
        <TableItem title="探亲福利费" prop="h300410"></TableItem>
        <TableItem title="电话费" prop="h300411"></TableItem>
        <TableItem title="办公业务费" prop="h300412"></TableItem>
        <TableItem title="差旅费" prop="h300413"></TableItem>
        <TableItem title="市内交通费" prop="h300414"></TableItem>
        <TableItem title="运杂费" prop="h300415"></TableItem>
        <TableItem title="汽车费" prop="h300416"></TableItem>
        <TableItem title="广告费" prop="h300417"></TableItem>
        <TableItem title="公关招待费" prop="h300418"></TableItem>
        <TableItem title="零星购置" prop="h300419"></TableItem>
        <TableItem title="奖品费" prop="h300420"></TableItem>
        <TableItem title="罚款赔偿" prop="h300421"></TableItem>
        <TableItem title="撤店直接损失" prop="h300422"></TableItem>
        <TableItem title="投资损失" prop="h300423"></TableItem>
        <TableItem title="医美费用" prop="h300424"></TableItem>
        <TableItem title="操作" align="center">
          <div class="actions" slot-scope="{data}">
            <span @click="remove(data)">删除</span>
          </div>
        </TableItem>
      </Table>
      <div class="margin-top-bottom">
        <Pagination v-model="pageInfo" align="center" layout="pager" small/>
      </div>
    </div>


    <Modal v-model="showForm1" type="drawer-right" hasCloseIcon>
      <div class="h-panel-bar">
			<span class="h-panel-title">
				<template v-if="auxiliary">{{ auxiliary.name }}</template><template
          v-if="auxiliaryItem">:{{ auxiliaryItem.name }}</template> 存款明细账</span>
        <span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
      </div>
      <Row type="flex" :space-x="10" class="margin-right-left margin-top" style="width: 700px">
        <Cell>
          <account-date-choose v-model="accountDate"/>
        </Cell>
        <Cell class="label">辅助类别：</Cell>
        <Cell>
          <Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType"
                  keyName="id" titleName="name"/>
        </Cell>
        <Cell>
          <Button :disabled="!auxiliary" :loading="loading1" color="primary" @click="doSearch">查询</Button>
        </Cell>
      </Row>
      <Row class="h-panel-body" type="flex" :space-x="10">
        <Cell :flex="1">
          <table class="balance" v-if="auxiliary">
            <thead class="header">
            <tr>
              <td rowspan="2">科目编码</td>
              <td rowspan="2">科目名称</td>
              <td colspan="3">本期发生额</td>
            </tr>
            <tr>
              <td>借方</td>
              <td>贷方</td>
              <td>合计</td>
            </tr>
            </thead>
            <tbody>
            <!-- 遍历数据列表，生成表格行 -->
            <tr v-for="item in dataList" :key="item.subjecId">
              <!-- 科目编码列，根据层级设置缩进 -->
              <td :style="{'padding-left':(item.level)*10+'px'}">{{ item.code }}</td>
              <!-- 科目名称列，根据层级设置缩进并添加hover效果 -->
              <td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{ item.name }}</span></td>
              <!-- 本期借方发生额列，右对齐并格式化数字 -->
              <td align="right">{{ item.currentDebitAmount|numFormat }}</td>
              <!-- 本期贷方发生额列，右对齐并格式化数字 -->
              <td align="right">{{ item.currentCreditAmount|numFormat }}</td>
              <td align="right">{{ ((item.currentDebitAmount || 0) - (item.currentCreditAmount || 0))|numFormat }}</td>
            </tr>
            <!-- 数据列表为空时显示暂无数据提示 -->
            <tr v-if="!dataList.length">
              <td colspan="8" class="text-center padding">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </Cell>
        <Cell v-width="200">
          <Tree @select="doSelect" :option="param" ref="auxiliary" filterable selectOnClick
                className="h-tree-theme-row-selected"></Tree>
        </Cell>
      </Row>

      <div class="text-center" style="margin-top: 40px;">
        <Button color="primary" @click="submit" :loading="loading1">保存当前数据</Button>
        <Button color="primary" @click="submitAll" :loading="loading1">保存所有数据</Button>
        <Button @click="showForm1=false">取消</Button>
      </div>
    </Modal>

  </app-content>

</template>

<script>
import {mapState} from 'vuex';
import moment from "moment/moment";
import * as XLSX from 'xlsx';

/**
 * 经营存款汇总
 */
export default {
  name: "QzJingYingck",
  data() {
    return {
      dataDian: [],
      // 已选中的行数据数组
      selectedItems: [],

      // 部门科目数据
      dataList: [],
      dataForm: {},
      showNumPrice: false,
      loading1: false,
      auxiliaryList: [],
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'name',
        dataMode: 'list',
        datas: []
      },
      accountDate: null,
      // 辅助类别-部门
      auxiliary: null,
      // 辅助项目-店名
      auxiliaryItem: null,
      auxiliaryType: [],
      showForm1: false,
      pageInfo: {
        // 当前页码，初始为第 1 页
        page: 1,
        // 数据总条数，初始为 0
        total: 0
      },
      // 日期选择器
      value: null,
      type: 'month',
      requiredSubjectCodes: [
        '1006','1007', '1008',
        '1010', '101001', '101002', '101003',
        '200201', '20020101', '20020102', '20020103',
        '200202', '200203',  '200205',
        '2004', '200401', '200402', '200403',
        '300401', '300402', '300403', '300404', '300405',
        '300406', '300407', '300408', '300409', '300410',
        '30041001', '30041002', '300411', '300412', '30041201',
        '30041202', '300413', '300414', '300415', '300416',
        '30041601', '30041602', '30041603', '30041604', '30041605',
        '30041606', '30041607', '30041608', '30041609', '30041610',
        '300417', '300418', '30041801', '30041802', '30041803',
        '300419', '300420', '300421', '30042101', '30042102',
        '300422', '300423', '300424'
      ],
    }
  },
  computed: {
    ...mapState(['currentAccountSets', 'myAccountSets'])
  },
  methods: {
    add() {
      this.showForm1 = true;
    },
    remove(item) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.bumenhuizong.jingyingck.delete(item.id).then(() => {
          this.loadListDian();
        })
      })
    },


    /**
     * 批量删除选中的经营部门数据
     *
     * 删除用户勾选的多条记录，删除前会显示确认对话框提示删除数量
     * 删除成功后自动刷新数据列表
     */
    batchDelete() {
      // 检查是否有选中项
      if (this.selectedItems.length === 0) {
        this.$Message.error('请选择要删除的数据！');
        return;
      }

      // 显示确认对话框，提示删除数量
      this.$Confirm(`确认要删除选中的 ${this.selectedItems.length} 条数据吗？`, '批量删除').then(() => {
        this.loading1 = true;
        // 提取所有选中项的 ID
        const ids = this.selectedItems.map(item => item.id);
        this.$api.bumenhuizong.jingyingck.batchDelete(ids).then(() => {
          this.$Message.success(`成功删除 ${this.selectedItems.length} 条数据！`);
          this.selectedItems = [];
          this.loadListDian();
        }).catch(() => {
          this.$Message.error('批量删除失败，请重试！');
        }).finally(() => {
          this.loading1 = false;
        });
      }).catch((error) => {
        // 处理用户取消操作，避免HeyUI的cancel错误
        if (error !== 'cancel') {
          const isCancelError = error === 'cancel' || (error && error.message === 'cancel')
          if (!isCancelError) {
            console.error('确认对话框错误:', error);
          }
        }
        // 用户点击取消按钮，不做任何处理
        this.loading1 = false;
      })
    },
    /**
     * 导出Excel
     */
    exportExcel() {
      try {
        // 导出所有数据
        const exportData = this.dataDian;

        if (exportData.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        // 准备导出数据，保持与表格显示一致的顺序
        const data = exportData.map((item, index) => {
          return {
            '序号': index + 1,
            '部门名称': item.dianName || '',
            '日期': item.heusanDate || '',
            '工资': item.h300401 || '',
            '房租费': item.h300402 || '',
            '装修费': item.h300403 || '',
            '燃气水电费': item.h300404 || '',
            '工商税费': item.h300405 || '',
            '折旧费': item.h300406 || '',
            '低值易耗': item.h300407 || '',
            '修理费': item.h300408 || '',
            '社保费': item.h300409 || '',
            '探亲福利费': item.h300410 || '',
            '电话费': item.h300411 || '',
            '办公业务费': item.h300412 || '',
            '差旅费': item.h300413 || '',
            '市内交通费': item.h300414 || '',
            '运杂费': item.h300415 || '',
            '汽车费': item.h300416 || '',
            '广告费': item.h300417 || '',
            '公关招待费': item.h300418 || '',
            '零星购置': item.h300419 || '',
            '奖品费': item.h300420 || '',
            '罚款赔偿': item.h300421 || '',
            '撤店直接损失': item.h300422 || '',
            '投资损失': item.h300423 || '',
            '医美费用': item.h300424 || ''
          };
        });

        // 创建工作表
        const ws = XLSX.utils.json_to_sheet(data, {skipHeader: false});

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '经营存款数据汇总');

        // 导出文件
        XLSX.writeFile(wb, '经营存款数据汇总.xlsx');

        // 显示成功提示
        this.$Message.success('数据导出成功，请查看浏览器下载列表');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('导出失败');
      }
    },

    /**
     * 处理表格行选择变化事件
     *
     * 当用户勾选或取消勾选表格行时，更新已选中项列表
     * @param {Array} checks - 当前选中的所有行数据数组
     */
    handleSelectChange(checks) {
      this.selectedItems = checks;
    },

    /**
     * 判断两个日期是否为同年同月
     * @param {String} date1 - 日期 1
     * @param {String} date2 - 日期 2
     * @returns {Boolean} - 是否为同年同月
     */
    isSameYearMonth(date1, date2) {
      if (!date1 || !date2) return false;
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      return d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth();
    },

    submit() {
      // 检查辅助核算项是否存在，避免无效请求
      if (this.auxiliaryItem) {
        // 检查名称是否包含BM
        if (!this.auxiliaryItem.name.includes('BM')) {
          this.$Message.error('请选择部门店名！');
          this.loading1 = false;
          return;
        }
        // 检查是否有数据
        if (this.dataList.length === 0) {
          this.$Message.error('该经营店本月无经营费用数据！不能保存！');
          this.loading1 = false;
          return;
        }
        // 设置加载状态为true，显示加载动画
        this.loading1 = true;

        // 先构建数据表单
        this.huoqudianshuju();

        // 刷新 dataDian 数据确保是最新的
        this.$api.bumenhuizong.jingyingck.list(this.accountDate).then(({data}) => {
          this.dataDian = data;

          // 在本地数据中检查是否已存在相同记录
          const existingItem = this.dataDian.find(item =>
              item.dianId === this.dataForm.dianId &&
              this.isSameYearMonth(item.heusanDate, this.dataForm.heusanDate)
          );

          if (existingItem) {
            this.$Message.error('本条记录已存在，请删除原有数据后再保存！');
            this.loading1 = false;
          } else {
            // 数据不存在，执行新增操作
            this.$api.bumenhuizong.jingyingck.save(this.dataForm).then(() => {
              this.loadListDian();
              this.$Message.success('数据保存成功！');
            }).finally(() => {
              this.loading1 = false;
            });
          }
        }).catch(() => {
          this.$Message.error('获取数据失败，请重试！');
          this.loading1 = false;
        });
      }
    },
    submit1() {
      if (this.auxiliaryItem) {
        // 设置加载状态为true，显示加载动画
        this.loading1 = true;
        console.log("dataForm 数据:", this.dataForm);
        console.log("dataForm JSON格式:", JSON.stringify(this.dataForm, null, 2));

        this.huoqudianshuju();
        console.log("dataForm 数据:", this.dataForm);
        console.log("dataForm JSON格式:", JSON.stringify(this.dataForm, null, 2));
        this.loading1 = false;
      } else {
        this.$Message.error('请选择经营店！');
        this.loading1 = false;
      }
    },
    // 在 loadList 方法中处理完 dataList 后，创建一个 code 到 item 的映射
    createCodeMap() {
      const codeMap = new Map();
      this.dataList.forEach(item => {
        codeMap.set(item.code, item);
      });
      return codeMap;
    },
    /**
     * 处理经营店数据
     */
    huoqudianshuju() {

      const codeMap = this.createCodeMap();
      // 移除 code 和空格前缀
      let dianName = this.auxiliaryItem.name;
      if (dianName.startsWith(this.auxiliaryItem.code + ' ')) {
        dianName = dianName.substring(this.auxiliaryItem.code.length + 1);
      }
      const newDataForm = {
        // accountSetsId: this.currentAccountSets.id,//账套ID
        companyName: this.currentAccountSets.companyName,//公司名称
        dianId: this.auxiliaryItem.id,//经营店ID
        dianName: dianName,//经营店名称
        fuzhuId: this.auxiliary.id,//辅助核算项ID
        fuzhuName: this.auxiliary.name,//辅助核算项名称
        heusanDate: this.accountDate,//辅助核算日期
        createDate: moment().format('YYYY-MM-DD HH:mm:ss')//创建时间
      };
      // 使用统一的科目代码处理，确保所有必要的科目都被包含
      // 遍历必填科目代码，根据科目余额数据构建表单数据
      // 对于每个科目代码，在codeMap中查找对应的科目信息
      // 计算科目的净额（借方余额 - 贷方余额），如果金额不为0则添加到dataForm中
      this.requiredSubjectCodes.forEach(code => {
        const item = codeMap.get(code);
        const amount = item ? ((item.currentDebitAmount || 0) - (item.currentCreditAmount || 0)) : 0;
        // 只有当金额不为 0 时才添加到 dataForm
        if (amount !== 0) {
          newDataForm[`h${code}`] = amount;
        }
      });

      // 特殊处理特定科目的映射关系
      const specialMappings = [
        {source: '1006', target: '300407'},
        {source: '1007', target: '300419'},
        {source: '1008', target: '300406'},
        {source: '101001', target: '300402'},
        {source: '101002', target: '300403'},
        {source: '101003', target: '300407'},
        {source: '200201', target: '300401'},
        {source: '200202', target: '300401'},
        {source: '200203', target: '300401'},
        // {source: '200204', target: '300409'},
        {source: '200205', target: '300401'},
        {source: '200401', target: '300404'},
        {source: '200402', target: '300405'},
        {source: '200403', target: '300412'},
      ];

      specialMappings.forEach(mapping => {
        const sourceItem = codeMap.get(mapping.source);
        if (sourceItem) {
          const sourceAmount = (sourceItem.currentDebitAmount || 0) - (sourceItem.currentCreditAmount || 0);
          if (sourceAmount !== 0) {
            // 将源科目金额加到目标科目上，如果目标科目已有值则累加
            const targetKey = `h${mapping.target}`;
            newDataForm[targetKey] = (newDataForm[targetKey] || 0) + sourceAmount;
          }
        }
      });

      // 使用 Vue.set 或直接赋值确保响应式更新
      this.$set(this, 'dataForm', newDataForm);
    },
    /**
     * 加载辅助核算类型数据
     *
     * @description 从API获取会计科目分类列表数据，设置辅助核算类型选项，并默认选中第一个选项
     * @returns {void}
     */
    loadAuxiliaryType1() {
      // 获取会计科目分类列表数据
      this.$api.setting.accountingCategory.list().then(({data}) => {
        this.auxiliaryType = data;
        // 如果存在数据，则默认选中第一个选项
        if (data.length) {
          this.auxiliary = data[0];
        }
      });
    },
    /**
     * 加载辅助余额列表数据
     *
     * 该函数根据辅助核算项ID和会计日期查询对应的辅助余额数据，
     * 查询过程中会显示加载状态，查询完成后更新数据列表并关闭加载状态
     * loadAuxiliarySubjectBalance1 科目1002银行存款相关的辅助余额数据
     */
    loadList() {
      // 检查辅助核算项是否存在，避免无效请求
      if (this.auxiliary) {
        // 设置加载状态为true，显示加载动画
        this.loading = true;
        // 调用API接口加载辅助余额数据
        this.$api.accountbook.loadAuxiliarySubjectBalance1({
          accountDate: this.accountDate,
          auxiliaryId: this.auxiliary.id,
          auxiliaryItemId: this.auxiliaryItem.id,
          showNumPrice: this.showNumPrice
        }).then(({data}) => {
          // 过滤出需要显示的科目数据
          this.dataList = data.filter(item =>
              this.requiredSubjectCodes.includes(item.code) &&
              ((item.currentDebitAmount || 0) !== 0 || (item.currentCreditAmount || 0) !== 0)
          );
        }).finally(() => {
          // 无论请求成功或失败，最终都要关闭加载状态
          this.loading = false;
        });
        // console.log("银行存款数据 JSON格式:", JSON.stringify(this.dataList, null, 2));
      }

    },


    loadListDian() {
      if (!this.accountDate) {
        // console.warn('accountDate 为空，不发起请求');
        return;
      }
      this.$api.bumenhuizong.jingyingck.list(this.accountDate).then(({data}) => {
        this.dataDian = data;
        // console.log("dataForm JSON格式:", JSON.stringify(this.dataDian, null, 2));
      });
    },


    /**
     * 加载辅助列表数据
     * @description 根据辅助ID加载相关的辅助列表数据，处理数据格式并初始化相关状态
     * @returns {void}
     */
    loadAuxiliaryList1() {
      // 清空数据列表
      this.dataList = [];
      // 调用API加载辅助列表数据
      this.$api.accountbook.loadAuxiliaryList({
        auxiliaryId: this.auxiliary.id
      }).then(({data}) => {
        // 筛选启用状态的数据 管理部门为true,
        data = data.filter(val => val.enable === false);
        // 格式化数据显示名称（编码+名称）
        data.forEach(val => val.name = val.code + " " + val.name);
        // 按编码进行排序
        data = data.sort((a, b) => a.code.localeCompare(b.code));
        // 设置参数中的数据源
        this.$set(this.param, "datas", data);
        // 如果存在数据，则设置默认选中项并加载列表
        if (data.length) {
          this.auxiliaryItem = data[0];
          this.loadList();
          // 在下次DOM更新后更新选择器的选中状态
          this.$nextTick(() => {
            this.$refs.auxiliary.updateSelect(this.auxiliaryItem.id);
          });
        }
      });
    },
    doSearch() {
      this.loadAuxiliaryList1();
    },
    doSelect(node) {
      this.auxiliaryItem = node;
      this.loadList();
    },

    /**
     * 批量保存所有辅助核算项目数据
     *
     * 该函数遍历 param.datas 中的所有节点，依次加载并保存每个节点的数据
     * 支持新增和更新操作，自动跳过已存在的记录（除非用户确认覆盖）
     */
    async submitAll() {
      // 检查是否有可保存的数据
      if (!this.param.datas || this.param.datas.length === 0) {
        this.$Message.error('没有可保存的数据！');
        return;
      }

      // 设置加载状态
      this.loading1 = true;

      let successCount = 0;
      let skipCount = 0;
      const total = this.param.datas.length;

      try {
        // 遍历所有节点
        for (let i = 0; i < total; i++) {
          const node = this.param.datas[i];

          // 检查名称是否包含 BM（部门标识）
          if (!node.name.includes('BM')) {
            skipCount++;
            continue;
          }

          // 加载当前节点的数据
          await this.loadListByNode(node);

          // 检查数据是否为空
          if (this.dataList.length === 0) {
            skipCount++;
            continue;
          }

          // 构建要保存的数据对象
          const dataToSave = this.buildDataForm(node);

          // 在本地数据中检查是否已存在相同记录
          const existingItem = this.dataDian.find(item =>
              item.dianId === dataToSave.dianId &&
              this.isSameYearMonth(item.heusanDate, dataToSave.heusanDate)
          );

          if (existingItem) {

            this.$Message.error(`第${i + 1}项 "${node.name}" 的数据已存在，请删除原数据后再进行批量保存！`);
            this.loading1 = false;
            this.loadListDian();
            return;
          } else {
            // 数据不存在，执行新增操作
            await this.$api.bumenhuizong.jingyingck.save(JSON.parse(JSON.stringify(dataToSave)));
            successCount++;
            this.$Message.success(`"${node.name}" 数据保存成功！`);
          }
        }

        // 刷新数据列表
        await this.loadListDian();

        // 显示汇总信息
        this.$Message.success(`批量保存完成！成功：${successCount}条，跳过：${skipCount}条，总计：${total}条`);

      } catch (error) {
        console.error('批量保存失败:', error);
        this.$Message.error('批量保存过程中发生错误，请查看控制台详情');
      } finally {
        this.loading1 = false;
      }
    },

    /**
     * 根据指定节点加载数据
     * @param {Object} node - 辅助核算节点
     */
    async loadListByNode(node) {
      if (!this.auxiliary) {
        this.dataList = [];
        return;
      }

      this.loading = true;
      try {
        const {data} = await this.$api.accountbook.loadAuxiliarySubjectBalance1({
          accountDate: this.accountDate,
          auxiliaryId: this.auxiliary.id,
          auxiliaryItemId: node.id,
          showNumPrice: this.showNumPrice,

        });

        // 过滤出需要显示的科目数据：在必需科目范围内且本期有发生额
        this.dataList = data.filter(item =>
            this.requiredSubjectCodes.includes(item.code) &&
            ((item.currentDebitAmount || 0) !== 0 || (item.currentCreditAmount || 0) !== 0)
        );
      } finally {
        this.loading = false;
      }
    },

    /**
     * 根据指定节点构建数据表单
     * @param {Object} node - 辅助核算节点
     * @returns {Object} 数据表单对象
     */
    buildDataForm(node) {
      const codeMap = this.createCodeMap();

      // 移除 code 和空格前缀
      let dianName = node.name;
      if (dianName.startsWith(node.code + ' ')) {
        dianName = dianName.substring(node.code.length + 1);
      }

      // 创建数据表单对象
      const dataForm = {
        companyName: this.currentAccountSets.companyName,
        dianId: node.id,
        dianName: dianName,
        fuzhuId: this.auxiliary.id,
        fuzhuName: this.auxiliary.name,
        heusanDate: this.accountDate,
        createDate: moment().format('YYYY-MM-DD HH:mm:ss')
      };

      // 添加科目金额
      this.requiredSubjectCodes.forEach(code => {
        const item = codeMap.get(code);
        const amount = item ? ((item.currentDebitAmount || 0) - (item.currentCreditAmount || 0)) : 0;
        if (amount !== 0) {
          dataForm[`h${code}`] = amount;
        }
      });
      // 特殊处理特定科目的映射关系
      const specialMappings = [
        {source: '1006', target: '300407'},
        {source: '1007', target: '300419'},
        {source: '1008', target: '300406'},
        {source: '101001', target: '300402'},
        {source: '101002', target: '300403'},
        {source: '101003', target: '300407'},
        {source: '200201', target: '300401'},
        {source: '200202', target: '300401'},
        {source: '200203', target: '300401'},
        // {source: '200204', target: '300409'},
        {source: '200205', target: '300401'},
        {source: '200401', target: '300404'},
        {source: '200402', target: '300405'},
        {source: '200403', target: '300412'},
      ];

      specialMappings.forEach(mapping => {
        const sourceItem = codeMap.get(mapping.source);
        if (sourceItem) {
          const sourceAmount = (sourceItem.currentDebitAmount || 0) - (sourceItem.currentCreditAmount || 0);
          if (sourceAmount !== 0) {
            // 将源科目金额加到目标科目上，如果目标科目已有值则累加
            const targetKey = `h${mapping.target}`;
            dataForm[targetKey] = (dataForm[targetKey] || 0) + sourceAmount;
          }
        }
      });

      return dataForm;
    },
  },
  watch: {
    accountDate(newVal) {
      if (newVal) {
        // 创建日期对象
        const date = new Date(newVal);

        // 检查当前日期是否已经是1号
        if (date.getDate() !== 1) {
          // 设置为1号
          date.setDate(1);
          // 格式化为 YYYY-MM-DD
          const firstDay = date.toISOString().slice(0, 10);

          // 更新 accountDate 为每月1号
          this.$nextTick(() => {
            if (this.accountDate !== firstDay) {
              this.accountDate = firstDay;
            }
          });
        }
      }
      this.loadListDian();
      if (this.auxiliary && this.auxiliaryItem) {
        this.loadList();
      }
    },
  },
  mounted() {
    this.loadAuxiliaryType1();

  }
}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}

.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 35px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>